import { Link } from "react-router-dom";
import { Phone, MessageCircle, Mail, MapPin, Zap } from "lucide-react";

export default function Footer() {
  return (
    <footer className="border-t border-black/10 bg-card">
      <div className="max-w-7xl mx-auto px-4 md:px-8 py-14 grid gap-10 md:grid-cols-4">
        <div className="md:col-span-2">
          <div className="flex items-center gap-3 mb-4">
            <img src="https://customer-assets-jt897jd0.emergentagent.net/job_battery-finder-5/artifacts/f661huv0_logo.jpg" alt="BBH Bharat Battery House" className="h-12 w-12 object-contain rounded-full ring-1 ring-black/10 bg-white" />
            <div className="leading-tight">
              <div className="font-display font-black text-lg">BHARAT BATTERY HOUSE</div>
              <div className="text-[10px] tracking-[0.24em] uppercase text-secondary/90">Amaron Battery Solutions</div>
            </div>
          </div>
          <p className="text-sm text-muted-foreground max-w-md">
            Trusted battery solutions provider for automotive, two-wheeler, inverter, HUPS and solar.
            Amaron product line available with expert guidance and doorstep support in Sikar, Rajasthan.
          </p>
          <p className="text-[11px] text-muted-foreground/70 mt-4">
            Not the official Amaron company page. Amaron product line offered as an authorized reseller.
          </p>
        </div>

        <div>
          <h4 className="font-display font-bold text-sm uppercase tracking-widest mb-4">Explore</h4>
          <ul className="space-y-2 text-sm text-foreground/80">
            <li><Link to="/" className="hover:text-secondary">Home</Link></li>
            <li><Link to="/find-battery" className="hover:text-secondary">Find Battery</Link></li>
            <li><Link to="/products" className="hover:text-secondary">Products</Link></li>
            <li><Link to="/products/hups-batteries" className="hover:text-secondary">HUPS Batteries</Link></li>
            <li><Link to="/about" className="hover:text-secondary">About</Link></li>
            <li><Link to="/contact" className="hover:text-secondary">Contact</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="font-display font-bold text-sm uppercase tracking-widest mb-4">Reach Us</h4>
          <ul className="space-y-3 text-sm text-foreground/80">
            <li className="flex items-start gap-2"><MapPin className="h-4 w-4 text-secondary mt-0.5" /><span>Near HP Petrol Pump,<br />Bajaj Road, Sikar (Raj.) 332001</span></li>
            <li className="flex items-center gap-2"><Phone className="h-4 w-4 text-secondary" /><a href="tel:+919829219117">+91 98292 19117</a></li>
            <li className="flex items-center gap-2"><Phone className="h-4 w-4 text-secondary" /><a href="tel:+919549390000">+91 95493 90000</a></li>
            <li className="flex items-center gap-2"><Phone className="h-4 w-4 text-secondary" /><a href="tel:+919530498888">+91 95304 98888</a></li>
            <li className="flex items-center gap-2"><Mail className="h-4 w-4 text-secondary" /><a href="mailto:amaronstoresikar@gmail.com">amaronstoresikar@gmail.com</a></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-black/10">
        <div className="max-w-7xl mx-auto px-4 md:px-8 py-4 flex flex-col md:flex-row items-center justify-between text-xs text-muted-foreground gap-2">
          <div>© {new Date().getFullYear()} Bharat Battery House. All rights reserved.</div>
          <div>Mon–Sat 10:00 am – 8:00 pm · Sunday Closed</div>
        </div>
      </div>
    </footer>
  );
}
